export default class ArrayUtils {
  public static previousOf<T>(
    arr: ReadonlyArray<T>,
    predicate: (e: T) => boolean,
  ): T | undefined {
    const index = arr.findIndex(predicate);
    const isNotFirstElement = index > 0;
    const elementFound = index > -1;

    if (elementFound && isNotFirstElement) {
      return arr[index - 1];
    } else {
      return undefined;
    }
  }

  public static followingOf<T>(
    arr: ReadonlyArray<T>,
    predicate: (e: T) => boolean,
  ): T | undefined {
    const index = arr.findIndex(predicate);
    const isNotLastElement = index < arr.length;
    const elementFound = index > -1;

    if (elementFound && isNotLastElement) {
      return arr[index + 1];
    } else {
      return undefined;
    }
  }

  public static insertAt<T>(
    arr: ReadonlyArray<T>,
    insertIndex: number,
    element: T,
  ): ReadonlyArray<T> {
    const fixedIndex =
      insertIndex < 0 ? 0 : insertIndex > arr.length ? arr.length : insertIndex;
    return arr.slice(0, fixedIndex).concat(element, arr.slice(fixedIndex));
  }

  public static insertAfter<T>(
    arr: ReadonlyArray<T>,
    predicate: (e: T) => boolean,
    element: T,
  ): ReadonlyArray<T> {
    const index = arr.findIndex(predicate);
    if (index < 0) {
      console.warn(
        "no element found which satisfies the given predicate in",
        arr,
      );
      return arr;
    } else {
      return this.insertAt(arr, index + 1, element);
    }
  }
}
